import { Swiper } from 'swiper';
import {Navigation, Pagination, Autoplay} from "swiper/modules";
Swiper.use([Navigation, Pagination, Autoplay]);

export default () => {
    const nodeSelectors = {
        container: '[js-big-slider-slider="container"]',
        slider: '[js-big-slider-slider="slider"]',
        pagination: '[js-big-slider-slider="pagination"]',
        prev: '[js-big-slider-slider="prev"]',
        next: '[js-big-slider-slider="next"]',
        play: '[js-big-slider-slider-play="play-button"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initSlider()
    }

    function initSlider() {
        let slidersContainers = document.querySelectorAll(nodeSelectors.container)

        slidersContainers.forEach(function (container, index) {
            let sliderEl = container.querySelector(nodeSelectors.slider)

            var bigSlider = new Swiper(sliderEl, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: false,
                autoHeight: true,
                speed: 500,
                // autoplay: {
                //     delay: 5000
                // },
                navigation: {
                    nextEl: container.querySelector(nodeSelectors.next),
                    prevEl: container.querySelector(nodeSelectors.prev),
                },
                pagination: {
                    el: container.querySelector(nodeSelectors.pagination),
                    clickable: true,
                },
                // on: {
                //     slideChange: function () {
                //     console.log('Slide changed to: ', this.activeIndex);
                //         $('.swiper-top-pagination ul li').removeClass('active');
                //         $('.swiper-top-pagination ul').find(['data-slide='+this.activeIndex]).addClass('active');
                //     },
                // },
                // breakpoints: {
                //     300: {
                //         slidesPerView: 1,
                //     },
                //     // when window width is >= 480px
                //     768: {
                //         slidesPerView: 2
                //     },
                //     // when window width is >= 640px
                //     1024: {
                //         slidesPerView: 4
                //     }
                // }
            });

            $('.swiper-top-pagination ul li').on('click', function(){
                $('.swiper-top-pagination ul li').removeClass('active');
                $(this).addClass('active');
                bigSlider.slideTo($(this).data('slide'))
            })
        })

    }

    return Object.freeze({
        init,
    })
}